 import playBtnOrange from "../../assets/images/all-img/about2/play-button-orange.png";
import play from "../../assets/images/all-img/about2/play.png";
import videoThumb2 from "../../assets/images/all-img/about2/video-thumb2.png";
import videoThumb3 from "../../assets/images/all-img/about2/video-thumb3.png";

import { useState } from "react";
import ModalVideo from "react-modal-video";

export default function VideoSection() {
	const [isOpen, setOpen] = useState(false);
	return (
		<div className="fugu--video-section3 fugu--section-padding">
			<div className="container">
				<div className="fugu--video-wrap">
					<div className="fugu--video-column">
						<div className="fugu--video-thumb wow fadeInUpX" data-wow-delay=".10s">
							<img src={videoThumb2} alt="" />
						</div>
						<div className="fugu--video-thumb wow fadeInUpX" data-wow-delay=".20s">
							<img src={videoThumb3} alt="" />
						</div>
					</div>
					<div className="fugu--popup" onClick={() => setOpen(true)}>
						<img src={playBtnOrange} alt="" />
						<div className="fugu--play-btn">
							<img src={play} alt="" />
						</div>
					</div>
				</div>
			</div>
			<ModalVideo
				channel="youtube"
				autoplay
				isOpen={isOpen}
				videoId="E1xkXZs0cAQ"
				onClose={() => setOpen(false)}
			/>
		</div>
	);
}
